import { Component } from '@angular/core';
import { AppConfig } from './../app/app.config';
import { Injectable } from '@angular/core';
import layer from 'layui-layer';
import * as $ from 'jquery';
import { NzNotificationService } from 'ng-zorro-antd';
@Injectable()
export class AlertService {
    constructor(
        private _notification: NzNotificationService,

        ) { }

    private alert(msg: string, title: string = '提示', isauto = true, icon = 1, yesFun = null, endFun = null) {
        if (this.isHidden()) {
            return;
        }
        if (isauto) {
            layer.alert(msg, {
                icon: icon,
                title: title == '' ? '提示' : title,
                time: 3000,
                yes: s => {
                    layer.close(s);
                    if (yesFun != null && $.isFunction(yesFun)) {
                        yesFun();
                    }
                },
                end: e => {
                    if (endFun != null && $.isFunction(endFun)) {
                        endFun();
                    }
                }
            });
        } else {
            layer.alert(msg, {
                icon: icon,
                title: title == '' ? '提示' : title,
                yes: s => {
                    layer.close(s);
                    if (yesFun != null && $.isFunction(yesFun)) {
                        yesFun();
                    }
                },
                end: e => {
                    if (endFun != null && $.isFunction(endFun)) {
                        endFun();
                    }
                }
            });
        }
    }

    //错误提示
    //TQQ 2017-04-27
    errorAlert(msg: string, title: string = '提示', isauto = true, yesFun = null, endFun = null) {
        this.alert(msg, title, isauto, 0, yesFun, endFun);
    }

    okAlert(msg: string, title: string = '提示', isauto = true, yesFun = null, endFun = null) {
        this.alert(msg, title, isauto, 1, yesFun, endFun);
    }

    //confirm弹窗
    //TQQ 2017-05-06
    confirmAlert(msg: string, title: string = '提示', btn = ['确定', '取消'], yesFun = null, cancelFun = null) {
        layer.confirm(msg, {
            title: title == '' ? '<i class="icon iconfont">&#xe639;</i>提示' : '<i class="icon iconfont">&#xe639;</i>' + title,
            icon: 7,
            btn: btn == null ? ['确定', '取消'] : btn,
            yes: s => {
                layer.close(s);
                if (yesFun != null && $.isFunction(yesFun)) {
                    yesFun();
                }
            },
            cancel: c => {
                layer.close(c);
                if (cancelFun != null && $.isFunction(cancelFun)) {
                    cancelFun();
                }
            }
        });
    }



    registerAlert(msg: string, title: string = '提示', btn = ['确定', '取消'], yesFun = null, cancelFun = null,) {
        layer.confirm(msg, {
            title: title == '' ? '' : '' + title,
            btn: btn == null ? ['确定', '取消'] : btn,
            yes: s => {
                layer.close(s);
                if (yesFun != null && $.isFunction(yesFun)) {
                    yesFun();
                }
            },
            cancel: c => {
                layer.close(c);
                if (cancelFun != null && $.isFunction(cancelFun)) {
                    cancelFun();
                }
            }
        });
    }
    msg(msg: string) {
        return layer.msg(msg);
    }

    closeAllLayer() {
        layer.closeAll();
    }

    //加载提示
    //TQQ 2017-04-27
    Loading(msg: string = '     加载中...') {
        return layer.msg('     ' + msg, {
            icon: 16
            , shade: 0.01
            , time: 0
        });;
    }

    //关闭加载提示
    //TQQ 2017-04-27
    CloseLoading() {
        layer.closeAll('');
    }

    // layer的open
    // TQQ 2017-04-27
    LayerOpen(title: string = "", content, area = ['auto', 'auto'], isBtn = false, buttons = ['确定', '取消'], yesFun = null, cancelFun = null, successFun = null, endFun = null) {
        
        layer.open({
            // title: '<i class="anticon anticon-info"></i>' + title,
            title: title,
            anim: 2,
            type: 1,
            skin: 'layui-layer-rim',
            area: area,
            content: content,
            icon: 7,
            btn: (isBtn ? (buttons == null ? ['确定', '取消'] : buttons) : null),
            //shadeClose:true,
            yes: s => {
                let loading = this.Loading();
                // layer.close(s);
                if (yesFun != null && $.isFunction(yesFun)) {
                    yesFun();
                }
            },
            cancel: function (index, layero) {
                if (cancelFun != null && $.isFunction(cancelFun)) {
                    cancelFun();
                }
                layer.close(index);
                return false;
            },
            success: s => {
                if (successFun != null && $.isFunction(successFun)) {
                    successFun();
                }
            },
            end: s => {
                if (endFun != null && $.isFunction(endFun)) {
                    endFun();
                }
                this.CloseLoading();
            }
        });
    }

    /**
     * // Alex 2018-05-18 增加自定义的skin配置项 和 第二个按钮的回调noFun配置项
     * @param title  弹出框标题
     * @param content  弹出框内容
     * @param area 设置区域及大小
     * @param isBtn 是否采用默认的button
     * @param buttons 自定义button显示的值
     * @param yesFun 确定按钮点击事件回掉
     * @param cancelFun 取消按钮点击事件回掉
     * @param successFun 成功后回掉
     * @param endFun 最后的回掉
     * @param skinSelf skin 是选择自定义的弹窗样式
     * @param noFun 点击第二个按钮时候的回调
     */
    LayerOpenAnother(title: string = "", content, area = ['auto', 'auto'], isBtn = false, buttons = ['确定', '取消'], yesFun = null, cancelFun = null, successFun = null, endFun = null, skinSelf = null, noFun = null) {
        layer.open({
            // title: '<i class="anticon anticon-info"></i>' + title,
            title: title,
            anim: 2,
            type: 1,
            skin: skinSelf || 'layui-layer-rim',
            area: area,
            content: content,
            icon: 7,
            btn: (isBtn ? (buttons == null ? ['确定', '取消'] : buttons) : null),
            //shadeClose:true,
            // 按钮一的回调
            yes: s => {
                layer.close(s);
                if (yesFun != null && $.isFunction(yesFun)) {
                    yesFun();
                }
            },
            // 按钮二的回调
            btn2: s => {
                layer.close(s);
                if (noFun != null && $.isFunction(noFun)) {
                    noFun();
                }
            },
            // 将弹窗“关闭”时调用
            cancel: function (index, layero) {
                if (cancelFun != null && $.isFunction(cancelFun)) {
                    cancelFun();
                }
                layer.close(index);
                return false;
            },
            success: s => {
                if (successFun != null && $.isFunction(successFun)) {
                    successFun();
                }
            },
            // 必定调用，最后调用
            end: s => {
                if (endFun != null && $.isFunction(endFun)) {
                    endFun();
                }
            }
        });
    }

    //layer的open
    //TQQ 2017-05-01
    LayerOpenUrl(title: string = "", content, buttons = ['确定', '取消'], area = ['auto', 'auto'], yesFun = null, successFun = null) {
        layer.open({
            title: title,
            anim: 2,
            type: 2,
            shade: 0,
            area: area,
            content: content,
            icon: 7,
            yes: s => {
                layer.close(s);
                if (yesFun != null && $.isFunction(yesFun)) {
                    yesFun();
                }
            },
            cancel: function (index, layero) {
                layer.close(index);
                return false;
            },
            success: function (index, layero) {
            }
        });
    }

    WarnInfor(content, title = '提示消息', type = 'info') {
        this._notification.blank( title, content);
    }

    getHiddenProp() {
        var prefixes = ['webkit', 'moz', 'ms', 'o'];

        // if 'hidden' is natively supported just return it
        if ('hidden' in document) return 'hidden';

        // otherwise loop over all the known prefixes until we find one
        for (var i = 0; i < prefixes.length; i++) {
            if ((prefixes[i] + 'Hidden') in document)
                return prefixes[i] + 'Hidden';
        }

        // otherwise it's not supported
        return null;
    }
    isHidden() {
        var prop = this.getHiddenProp();
        if (!prop) return false;

        return document[prop];
    }
}




// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/providers/alert.service.ts